import { SearchFacets } from 'api/graphQL/types/product.type'
import React from 'react'
import { ProductListingDialogFacet } from '.'

export interface DialogFilterProviderProps {
    getFacetOptions: (facet: ProductListingDialogFacet) => string[]
    getProductFacetOptions?: (
        facet: ProductListingDialogFacet
    ) => Partial<SearchFacets>[]
    handleFacetSelectedChange: (
        facet: ProductListingDialogFacet,
        value: string[],
        productTypeFacets?: Partial<SearchFacets>[],
        inputValue?: string
    ) => void
    removeProductType?: (value: string[]) => void
    isProductTypeFacetsLoading?: boolean
}
export interface DialogFilterContextValue {
    getFacetOptions: (facet: ProductListingDialogFacet) => string[]
    getProductFacetOptions?: (
        facet: ProductListingDialogFacet
    ) => Partial<SearchFacets>[]
    handleFacetSelectedChange: (
        facet: ProductListingDialogFacet,
        value: string[],
        productTypeFacets?: Partial<SearchFacets>[],
        inputValue?: string
    ) => void
    removeProductType?: (value: string[]) => void
    isProductTypeFacetsLoading?: boolean
}

export const DialogFilterContext = React.createContext(
    {} as DialogFilterContextValue
)

export const DialogFilterProvider: React.FC<DialogFilterProviderProps> = ({
    getFacetOptions,
    getProductFacetOptions,
    handleFacetSelectedChange,
    removeProductType,
    children,
    isProductTypeFacetsLoading = false,
}) => {
    const value: DialogFilterContextValue = {
        getFacetOptions,
        getProductFacetOptions,
        handleFacetSelectedChange,
        removeProductType,
        isProductTypeFacetsLoading,
    }

    return (
        <DialogFilterContext.Provider value={value}>
            {children}
        </DialogFilterContext.Provider>
    )
}
